// Transforms the first letter to uppercase
export const toUppercase = (name: string) => `${name?.charAt(0).toUpperCase() + name?.slice(1)}`;
// Camelize a string
export const camelize = (str: string) => (str ? toUppercase(str.replace(/-./g, (x) => x[1].toUpperCase())) : "");
// Convert camel case to words
export const camelCaseToWords = (s: string) => {
  return s.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1");
};
